import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {CoreCommonModule} from '@core/common.module';
import {NotFoundComponent} from './not-found/not-found.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { TranslateModule } from '@ngx-translate/core';


// routing
const routes: Routes = [

];

@NgModule({
  declarations: [NotFoundComponent, NotAuthorizedComponent],
  imports: [CommonModule, RouterModule.forChild(routes), CoreCommonModule, TranslateModule],
  exports: [NotFoundComponent, NotAuthorizedComponent, RouterModule]
})
export class MiscellaneousModule {
}
